import { HttpErrorResponse } from '@angular/common/http';

import { AppError } from './app-error';

export interface FieldValidationErrorData {
  fieldErrors: Record<string, string>;
}

interface FieldError {
  property: string;
  message: string;
}

export class FieldValidationError extends AppError<FieldValidationErrorData> {
  constructor(source: HttpErrorResponse, translationKey = 'common.errors.unexpected') {
    super(source, translationKey, null, { fieldErrors: FieldValidationError.toFieldErrors(source) });
  }

  private static toFieldErrors(source: HttpErrorResponse): Record<string, string> {
    const errors: FieldError[] = Array.isArray(source.error?.errors) ? source.error.errors : [];

    return errors.reduce<Record<string, string>>((acc, error) => {
      if (error?.property && error?.message) {
        acc[error.property] = error.message;
      }

      return acc;
    }, {});
  }
}
